module.exports = __webpack_public_path__ + "static/media/completed.346865e5.svg";